import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import { fetchDynamicFieldById } from "../../redux/dynamicField/dynamicFieldThunks";
import { clearDynamicField } from "../../redux/dynamicField/dynamicFieldSlice";
import moment from "moment";
import { formatAction } from "../../utils/formatAction";


const ViewDynamicFieldPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    current: field,
    loading,
    error,
  } = useSelector((state) => state.dynamicField);

  const [activeTab, setActiveTab] = useState("field-info");

  useEffect(() => {
    if (id) {
      dispatch(fetchDynamicFieldById({ id, navigate }));
    }

    return () => {
      dispatch(clearDynamicField());
    };
  }, [id, dispatch, navigate]);

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {error && (
              <DengerAlert
                message={error || "Failed to fetch field"}
                onClose={() => { }}
              />
            )}

            {/* Tabs */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "field-info" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("field-info")}
                  type="button"
                  role="tab"
                >
                  Preference Info
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {/* Field Info Tab */}
              <div
                className={`tab-pane fade ${activeTab === "field-info" ? "show active" : ""
                  }`}
                role="tabpanel"
              >
                {field ? (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Title:
                      </label>
                      {field.title || "N/A"}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Type:
                      </label>
                      {formatAction(field?.type || "N/A")}

                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Sub Type:
                      </label>
                      {field.subType || "N/A"}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Multi Select:
                      </label>
                      {field.multiSelect ? "Yes" : "No"}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Status:
                      </label>
                      {field.isActive ? "Active" : "Inactive"}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Created At:
                      </label>
                      {moment(field.createdAt).format("DD-MM-YYYY")}
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Options:
                      </label>
                      {field?.options?.length > 0 ? (
                        <ul
                          className="mb-0 ps-3"
                          style={{ listStyleType: "disc" }}
                        >
                          {field.options.map((opt, index) => (
                            <li key={opt._id || index}>
                              {opt.label}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        "No options available"
                      )}
                    </div>
                  </div>
                ) : (
                  <div>No Preferences Found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDynamicFieldPage;
